import * as angular from 'angular';
import * as _ from 'lodash';

import { Steps, Configurations, createConfiguration } from '../../../common/Steps';
import { Step } from '../../groupComputation/Step';
import { ILoggerService, ITaskService, IUserSettingsService } from '../../../services';
import { ComponentDefinition, Group, IFrequency } from '../../../models';

const IGNORE_PARENTS = 'Ignore parents';
const CONFIGURATION = 'REPROCESS_CONFIGURATION';

class ReprocessGroupsModalController implements angular.IComponentController {
    batchFrequency: IFrequency;
    beginDate: string;
    endDate: string;
    formController: angular.IFormController;
    isLoading: boolean;
    isRefreshPrevented: boolean = true;
    leaves: Step[];
    selectedGroups: Group[];
    steps: Step[];

    readonly groups: any[];

    private _steps: { label: string; propertyName: string }[];

    static $inject = ['$scope', 'taskService', 'loggerService', 'userSettingsService'];

    constructor(
        private _$scope: angular.IScope,
        private _taskService: ITaskService,
        private _loggerService: ILoggerService,
        private _userSettingsService: IUserSettingsService
    ) {
    }

    $onInit() {
        this._steps = Steps.concat(Configurations);
        const data = this._userSettingsService.getApplicationSetting<Step[]>(CONFIGURATION);
        let steps;
        if (!data) {
            steps = this.createSteps();
        } else {
            steps = this._steps
                .map(d => {
                    const existing = _.find(data, s => s.label === d.label);
                    return {
                        label: d.label,
                        value: existing ? existing.value : false
                    };
                });
        }
        this.steps = steps;
        this.leaves = [
            {
                label: IGNORE_PARENTS,
                value: true
            }
        ];
        this._$scope.$watch(() => this.leaves[0].value, newValue => {
            this.selectedGroups = this.filterGroups(this.groups, newValue);
        });
    }

    private createSteps() {
        const steps = Steps.map(d => {
            return {
                label: d.label,
                value: true
            };
        })
            .concat(Configurations.map(d => {
                return {
                    label: d.label,
                    value: false
                };
            }));
        return steps;
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['groups'] && changesObj['groups'].currentValue) {
            this.selectedGroups = this.filterGroups(changesObj['groups'].currentValue, true);

        }
    }

    startTask() {
        this._userSettingsService.setApplicationSetting(CONFIGURATION, this.steps);
        const configuration = createConfiguration(
            { beginDate: this.beginDate, endDate: this.endDate },
            this.selectedGroups.map(d => d.guid),
            this.steps,
            this.batchFrequency
        );

        this._taskService.createWorkflowTask(configuration)
            .then(data => {
                this._loggerService.logSuccess('Task successfully created');
            }).catch(reason => {
                this._loggerService.logError('Failed to create task.');
            });
    }

    private filterGroups(inputGroups: any[], hasLeavesOnly: boolean): any[] {
        if (!inputGroups) {
            return [];
        }
        const groups = hasLeavesOnly
            ? inputGroups.filter(g => !g.children || !g.children.length || _.every(g.children, c => inputGroups.indexOf(c) < 0))
            : this.groups.concat();
        return groups;
    }
}

export const wtReprocessGroupsModal: ComponentDefinition = {
    componentId: 'wtReprocessGroupsModal',
    controller: ReprocessGroupsModalController,
    template: require('./reprocessGroupsModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        groups: '<'
    }
};